import { RadioGroup } from "@headlessui/react";
import { useState } from "react";
import SubscriptionFormContext, {
  SubscriptionFormContextType,
} from "./SubscriptionFormContext";
import PurchaseTypeOption from "./PurchaseTypeOption";
import FrequencySelector from "./FrequencySelector";
import BenefitsList from "./BenefitsList";
import RefillPreferenceSelector from "./RefillPreferenceSelector";
import CartAPIForm from "./CartAPIForm";
import BuyButton from "./BuyButton";

export const SubscriptionFormConfig = {
  key: "subscription-form",
  component: SubscriptionForm,
};

export default function SubscriptionForm(
  subscriptionFormContext: SubscriptionFormContextType
) {
  const {
    labels: { oneTimePurchase, subscription },
    prices: { basePrice, subscriptionPrice },
    frequencies,
  } = subscriptionFormContext;
  const [isSubscribing, setIsSubscribing] = useState(true);
  const [sellingPlanId, setSellingPlanId] = useState<string>(
    frequencies[0].sellingPlanId
  );
  const [isSubscribingToRefills, setIsSubscribingToRefills] = useState(true);
  const [quantity, setQuantity] = useState(1);

  return (
    <SubscriptionFormContext.Provider value={subscriptionFormContext}>
      <div className="xflex xflex-col xitems-center xgap-4 md:xgap-6 xw-full">
        <div className="xflex xflex-col xitems-center xgap-2 md:xgap-4 xw-full">
          <RadioGroup
            value={isSubscribing}
            onChange={setIsSubscribing}
            aria-label="Purchase type"
            className="xflex xflex-col xgap-2 md:xgap-4 xw-full"
          >
            <PurchaseTypeOption
              label={oneTimePurchase}
              price={basePrice}
              value={false}
            />
            <PurchaseTypeOption
              compareAtPrice={basePrice}
              highlight={true}
              label={subscription}
              price={subscriptionPrice}
              value={true}
            />
          </RadioGroup>
          {isSubscribing && (
            <div
              className="
            xflex xflex-col xgap-4
            xw-[95%] xh-128
            xborder-4 xborder-dark-green xrounded-3xl
            xpx-6 md:xpx-8 xpy-4 md:xpy-6
          "
            >
              <FrequencySelector
                sellingPlanId={sellingPlanId}
                setSellingPlanId={setSellingPlanId}
              />
              <BenefitsList />
              <RefillPreferenceSelector
                isSubscribingToRefills={isSubscribingToRefills}
                onIsSubscribingToRefillsChange={setIsSubscribingToRefills}
              />
            </div>
          )}
          <CartAPIForm
            isSubscribing={isSubscribing}
            sellingPlanId={sellingPlanId}
            isSubscribingToRefills={isSubscribingToRefills}
            quantity={quantity}
          />
        </div>
        <BuyButton quantity={quantity} setQuantity={setQuantity} />
      </div>
    </SubscriptionFormContext.Provider>
  );
}
